import { GTMWindow } from '../model/GTMWindow';

export const getHref = (windowReference: GTMWindow): string =>
    windowReference.document.location.href;
